// App.js
import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./App.css";
import "./styles/theme.css"; // AIWave Theme
import "./styles/animations.css"; // Gradient text utilities
import { ThemeProvider } from "./context/ThemeContext"; // Theme Context
import ScrollProgress from "./components/ScrollProgress";
import MainLayout from "./components/MainLayout";
import Login from "./components/Login";
import Register from "./components/Register";
import ForgotPassword from "./components/ForgotPassword";
import Account from "./components/Account";
import Profile from "./components/Profile";
import ChangePassword from "./components/ChangePassword";
import Subscriptions from "./components/Subscriptions";
import Payment from "./components/Payment";
import Success from "./components/Success";
import Cancel from "./components/Cancel";
import Contact from "./components/Contact";
import About from "./components/About";
import PrivacyPolicy from "./components/PrivacyPolicy";
import TermsAndConditions from "./components/TermsAndConditions";
import FooterTermsAndConditions from "./components/FooterTermsAndConditions";
import PaymentTermsAndConditions from "./components/PaymentTermsAndConditions";
import Admin from "./admin/Admin";

function App() {
  return (
    <ThemeProvider>
      <Router>
        <ScrollProgress />
        <Routes>
          <Route path="/" element={<MainLayout />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/account" element={<Account />} />
          <Route path="/profile" element={<Profile />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/subscription" element={<Subscriptions />} />
          <Route path="/payment" element={<Payment />} />
          <Route path="/success" element={<Success />} />
          <Route path="/cancel" element={<Cancel />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/about" element={<About />} />
          <Route path="/privacypolicy" element={<PrivacyPolicy />} />
          <Route path="/terms-and-conditions" element={<TermsAndConditions />} />
          <Route path="/terms" element={<Navigate to="/terms-and-conditions" replace />} />
          <Route path="/footer-terms-and-conditions" element={<FooterTermsAndConditions />} />
          <Route path="/payment-terms-and-conditions" element={<PaymentTermsAndConditions />} />
          <Route path="/admin" element={<Admin />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
